import type { Feedback } from "@stockline/shared/types/core/feedback"
import type { OfflineResourceConfig } from "../../../types"
import { FEEDBACK_TABLE } from "./db"

export const feedbackConfig: OfflineResourceConfig<Feedback> = {
  name: "feedbacks",
  // STK-1324: deferred, non-blocking -- hydrated via the SSE replay handshake
  // (cursor=0 full-table replay) AFTER readiness, not the cold-start waves.
  tier: "background",
  endpoints: {
    full: "/api/v2/feedbacks",
    delta: "/api/v2/feedbacks/changes",
    push: "/api/v2/feedbacks/changes",
  },
  tableName: FEEDBACK_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    authorUserId: "authorUserId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
